import RiskStatusIcon from "@/views/Risk/shared/RiskStatusIcon";

type RiskScoreCellProps = {
  value: string | number | boolean | null | undefined;
  band: string | number | boolean | null | undefined;
};

const getTone = (
  band: RiskScoreCellProps["band"],
): "red" | "yellow" | "green" | "default" => {
  if (typeof band !== "string") return "default";
  const normalized = band.trim().toLowerCase();
  if (normalized === "red") return "red";
  if (normalized === "yellow") return "yellow";
  if (normalized === "green") return "green";
  return "default";
};

const getDisplayValue = (value: RiskScoreCellProps["value"]) => {
  if (value === null || value === undefined || value === "") return "-";
  return String(value);
};

export default function RiskScoreCell({ value, band }: RiskScoreCellProps) {
  return (
    <div className="flex items-center gap-2 font-medium text-[#2B4752]">
      <RiskStatusIcon tone={getTone(band)} />
      <span>{getDisplayValue(value)}</span>
    </div>
  );
}
